<template>
  <div>
    <riseup-header/>
    <div class="connection-failure">
        <div class="content">
          <div class="animation-container">
            <lottie-player class="broken"
                           :src="JSON.stringify(require('@/assets/animations/broken.json'))"
                           :preserveAspectRatio="'xMidYMax'"
                           autoplay
                           loop/>
          </div>
          <div class="title">החיבור לא הצליח,</div>
          <div class="title">אבל יש מה לעשות!</div>
          <div class="information-accordion">
            <separator></separator>
            <div class="expandable-question">
              <expandable-summary-row text-style="medium"
                                      :with-shadow=false
                                      :is-expandable=true
                                      class="row"
                                      :header-text="'אם ניסית לחבר חשבון של שותפים'">
                <template v-slot:content>
                  <div class="answer">
                    צריך לוודא שזיהוי המשתמש מול הבנק מתאים לתעודת הזהות שהכנסת ב-RiseUp.
                  </div>
                </template>
              </expandable-summary-row>
            </div>
            <separator></separator>
            <div class="expandable-question">
              <expandable-summary-row text-style="medium"
                                      :with-shadow=false
                                      :is-expandable=true
                                      :header-text="errorTitle">
                <template v-slot:content>
                  <div class="answer">
                    מגבלת הזמן לאישור החיבור בבנק היא עשר דקות. אם נראה לך שהזמן עבר, אפשר לנסות שוב.
                  </div>
                </template>
              </expandable-summary-row>
            </div>
            <separator></separator>
          </div>
          <div class="button-wrapper">
            <riseup-button class="button"
                           :action="this.closeAction"
                           :title="'לנסות שוב'"
                           :size="'slim'"/>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import RiseupHeader from '@/base-components/app-header/RiseupHeader';
import BaseUI from 'base-ui';
import ExpandableSummaryRow
  // eslint-disable-next-line max-len
  from '@/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/generic-components/cashflow-types/cashflow-types-base/ExpandableSummaryRow';
import Intercom from '@/Intercom';

export default {
  name: 'ConnectionFailure',
  components: {
    RiseupHeader,
    RiseupButton: BaseUI.RiseupButton,
    ExpandableSummaryRow,
    Separator: BaseUI.Separator,
  },
  props: {
    source: {
      type: Object,
      required: true,
    },
    closeAction: {
      type: Function,
      required: true,
    },
  },
  created() {
    Intercom.show();
  },
  computed: {
    errorTitle() {
      return ` אם קיבלת הודעת שגיאה ב${this.source.displayName}`;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../scss/mixins';

  .connection-failure {
    width: 100%;
    height: 100%;
    .content {
      color: $riseup_black;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      .animation-container {
        height: 250px;
      }
      .title {
        font-size: 24px;
        line-height: 32px;
        font-weight: bold;
        font-family: SimplerPro;
      }

      .information-accordion {
        margin-top: 50px;
        width: 100%;

        .expandable-question {
          font-size: 18px;
          line-height: 24px;
          padding: 0 30px;
          text-align: right;

          ::v-deep .sections-label {
            padding: 25px 0px;

            .header-text {
              padding: 0 0 0 0;
            }
          }

          .answer {
            font-size: 18px;
            line-height: 25px;
            padding-bottom: 20px;
            font-family: SimplerPro;
          }
        }
      }

      .button-wrapper {
        padding: 0 35px 27px 27px;
        width: 100%;
        .button {
          margin-top: 25px;
          margin-bottom: 35px;
        }
      }
    }
  }
</style>
